@if (visible) {
    <div
        class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60"
        (click)="onOverlayClick()"
    >
        <div
            class="flex flex-col items-center justify-center bg-transparent"
            (click)="$event.stopPropagation()"
        >
            <svg
                width="94"
                height="90"
                viewBox="0 0 94 90"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="success-icon"
                style="position: relative"
            >
                <!-- Estrela com buraco do check -->
                <path
                    d="M93.6751 45.04L83.3131 33.191L84.7571 17.521L69.4261 14.039L61.4001 0.449005L46.9611 6.649L32.5221 0.449005L24.4961 13.996L9.16507 17.436L10.6091 33.149L0.24707 45.04L10.6091 56.888L9.16507 72.601L24.4961 76.083L32.5221 89.63L46.9611 83.387L61.4001 89.587L69.4261 76.04L84.7571 72.558L83.3131 56.888L93.6751 45.04ZM38.8471 65.084L22.7121 48.904L28.9971 42.619L38.8471 52.514L63.6931 27.586L69.9781 33.871L38.8471 65.084Z"
                    fill="white"
                    fill-rule="evenodd"
                    class="star-with-hole"
                />
            </svg>
            <div class="text-white text-xl font-semibold text-center drop-shadow-lg p-6 success-message">
                {{ message }}
            </div>
        </div>
    </div>
}
